import { auth } from './firebase';

export async function getFirebaseAuthorizationHeaders() {
  await auth?.authStateReady?.();
  const token = await auth?.currentUser?.getIdToken?.();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function withFirebaseAuthorization(options = {}) {
  const authHeaders = await getFirebaseAuthorizationHeaders();
  if (!Object.keys(authHeaders).length) {
    return options;
  }

  return {
    ...options,
    headers: {
      ...(options.headers || {}),
      ...authHeaders,
    },
  };
}

export async function authorizedFetch(url, options = {}) {
  return fetch(url, await withFirebaseAuthorization(options));
}
